import { render, staticRenderFns } from "./SuperadminLayout.vue?vue&type=template&id=aac682b8&"
import script from "./SuperadminLayout.vue?vue&type=script&lang=js&"
export * from "./SuperadminLayout.vue?vue&type=script&lang=js&"
import style0 from "./SuperadminLayout.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports